import React from 'react';
import {useTranslation} from 'react-i18next';
import {Snackbar} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";


export default function PMCSnackbar({
                                        open,
                                        onClose,
                                        message,
                                        severity,
                                        autoHideDuration,
                                    }) {
    const {t} = useTranslation();


    return (
        <Snackbar open={open} autoHideDuration={autoHideDuration | 10000} onClose={onClose}
                  anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            <MuiAlert elevation={6} variant="filled" onClose={onClose} severity={severity}>
                {message}
            </MuiAlert>
        </Snackbar>
    );
}

